// src/components/AboutSection.jsx
import React from "react";

export default function AboutSection() {
  return (
    <section className="py-16 sm:py-20 bg-white/70">
      <div className="max-w-7xl mx-auto px-4">
        {/* Title */}
        <h2
          className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-center text-brand-primary mb-10"
          style={{ fontFamily: "var(--font-head)" }}
        >
          About Once A Hunt
        </h2>

        {/* Two-column layout */}
        <div className="grid lg:grid-cols-2 gap-8 items-stretch">
          {/* Left image */}
          <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
            <img
              src="/about-book.jpg"
              alt="About Once A Hunt"
              className="w-full h-[260px] sm:h-[340px] lg:h-full object-cover"
              loading="lazy"
            />
          </div>

          {/* Right panel */}
          <div
            className="relative rounded-2xl overflow-hidden shadow-lg border"
            style={{ background: "rgba(166, 227, 161, 0.35)" }}
          >
            {/* Clouds (decor) */}
            <div
              className="absolute -top-8 -left-10 w-44 h-28 rounded-full opacity-80"
              style={{ background: "rgba(255,255,255,0.85)" }}
              aria-hidden="true"
            />
            <div
              className="absolute -top-10 left-16 w-52 h-32 rounded-full opacity-90"
              style={{ background: "rgba(255,255,255,0.92)" }}
              aria-hidden="true"
            />
            <div
              className="absolute -top-12 right-10 w-56 h-36 rounded-full opacity-80"
              style={{ background: "rgba(207, 233, 255, 0.85)" }}
              aria-hidden="true"
            />

            <div className="relative p-8 sm:p-10 text-center">
              <div
                className="text-sm font-extrabold tracking-wide text-brand-ink/70 mb-3"
                style={{ fontFamily: "var(--font-head)" }}
              >
                Our Story
              </div>

              <div
                className="text-2xl sm:text-3xl font-extrabold text-brand-primary mb-4"
                style={{ fontFamily: "var(--font-head)" }}
              >
                Learning should feel like play.
              </div>

              <p className="text-brand-ink/80 text-base sm:text-lg leading-relaxed max-w-xl mx-auto">
                Once-A-Hunt began at home. As a mom, I wanted to teach my kids — but I
                didn’t want learning to replace playtime. So I started turning practice
                into adventures: questions into clues, lessons into movement, and learning
                into laughter.
                <br />
                <br />
                Now families can create scavenger hunts that help kids explore, build
                skills, and make memories with friends and family — all while having fun.
              </p>

              <div className="mt-8">
                <button
                  type="button"
                  className="inline-flex items-center justify-center rounded-full px-7 py-3 font-extrabold text-white bg-[#1f6f63] hover:opacity-90 transition shadow"
                  style={{ fontFamily: "var(--font-head)" }}
                >
                  Discover More
                </button>
              </div>

              {/* Cute doodles */}
              <div className="absolute left-8 bottom-6 opacity-90" aria-hidden="true">
                <svg width="62" height="62" viewBox="0 0 64 64">
                  <path d="M24 12c0-6 6-10 8-2 2-8 8-4 8 2v14H24V12z" fill="#fff" />
                  <path d="M18 28c0-8 6-14 14-14s14 6 14 14v20H18V28z" fill="#fff" />
                  <circle cx="28" cy="34" r="2" fill="#1f2937" />
                  <circle cx="36" cy="34" r="2" fill="#1f2937" />
                  <path d="M32 36c2 2 2 4 0 6c-2-2-2-4 0-6z" fill="#f28c28" />
                  <path
                    d="M50 46c0 6-5 10-12 10"
                    fill="none"
                    stroke="#1f6f63"
                    strokeWidth="3"
                    strokeLinecap="round"
                  />
                </svg>
              </div>

              <div className="absolute right-8 bottom-6 opacity-70" aria-hidden="true">
                <svg width="70" height="40" viewBox="0 0 80 50">
                  <path
                    d="M40 48c0-18 10-34 18-40"
                    stroke="#1f6f63"
                    strokeWidth="4"
                    strokeLinecap="round"
                    fill="none"
                  />
                  <path
                    d="M40 48c0-16-8-30-16-38"
                    stroke="#1f6f63"
                    strokeWidth="4"
                    strokeLinecap="round"
                    fill="none"
                  />
                  <path
                    d="M40 48c0-12 0-22 0-34"
                    stroke="#1f6f63"
                    strokeWidth="4"
                    strokeLinecap="round"
                    fill="none"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
